import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PageFaqDetailComponent from '../components/fqaDetail';

import { Creators } from '../redux';

const mapStateToProps = () => {
  return {
    type: '',
    isProcessing: '',
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...Creators,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PageFaqDetailComponent);
